import { lazy } from 'react';
import RouteErrorBoundary from './_shared/ErrorScreens/RouteErrorBoundary';
import AuthenticationScreen from './_shared/Authenticator';
import TwoAuthDiasbledScreen from './_shared/Authenticator/authVerificationCode';
import ContractStatusScreen from './InternalUser/ContractScreens/ContractStatusTab/listScreen.jsx';
import CostCenter from './InternalUser/Vehicles/CostCenterScreen/costCenter';
import EditVehicle from './InternalUser/Controllers/Vehicles/editVehicle';
import AddEditCustomer from './InternalUser/Controllers/Customers/addCustomer';
import JobScreen from './InternalUser/Controllers/JOBS/JobScreen';
import InternalUserJobsScreen from './InternalUser/Controllers/JOBS/InternalJobsScreen';
import EditDepot from './InternalUser/Controllers/Vehicles/VehicleDepots/editDashboard';
import ContractField from './InternalUser/Controllers/Vehicles/Contract/contractTab';
import EnquiryEditModal from './InternalUser/Enquiries/EditEnquiry';
import AddEnquiries from './InternalUser/Enquiries/AddNewEnquiries';
import JobReportScreen from './InternalUser/Controllers/JOBS/jobReporting';
import VorReportingModal from './InternalUser/VorReporting/vorReporting';
import VORTypeDetail from './VOR/VORTypeDetailScreen/vorTypeDetail';
import BreakDownDashboard from './InternalUser/Maintenance/BreakDown/breakDownDashboard';
import BreakdownDefectReporting from './InternalUser/Maintenance/BreakDownDefectReporting';
import DefectEditDetails from './InternalUser/Maintenance/Defects/DefectEditDetails';
import ServiceAgentDashboard from './ServiceAgent/Dashboard/ServiceAgentDash';
import GetAgentLocation from './InternalUser/Maintenance/BreakDown/getLocations';

// Route pages are lazy-loaded so each is its own code-split chunk
const Error404 = lazy(() => import('./_shared/ErrorScreens/Error404'));
const SharedHome = lazy(() => import('./_shared/Home'));
const Login = lazy(() => import('./_shared/Login'));
const Logout = lazy(() => import('./_shared/Logout'));
const ResetPassword = lazy(() => import('./_shared/ResetPassword'));
const Help = lazy(() => import('./_shared/Help'));
const ContractStatusTabScreen = lazy(() => import('./InternalUser/ContractScreens/ContractStatusTab'));
const NotesWrapperListScreen = lazy(() => import('./InternalUser/Controllers/Notes/notesGrid'));
const ContractList = lazy(() => import('./InternalUser/ContractScreens/ContractList'));
const ContractEditScreen = lazy(() => import('./InternalUser/ContractScreens/ContractList/contractAddEditModal'));
const ContractMaintenanceScreen = lazy(() => import('./InternalUser/ContractScreens/ContractMaintenance'));
const HireFleetScreen = lazy(() => import('./InternalUser/ContractScreens/HireFleet'));
const DashboardRecallsList = lazy(() => import('./InternalUser/RecallDashDetails'));
const ModelScreen = lazy(() => import('./InternalUser/Vehicles/ModelScreen/modelScreen'));
const VehicleManufacturer = lazy(() => import('./InternalUser/Vehicles/MakeScreen/vehicleManufacturer'));
const VmrsSubCategoryScreen = lazy(() => import('./InternalUser/Vehicles/VMRS/VmrsSubSategory/VmrsSubcategory'));
const VmrsCategory = lazy(() => import('./InternalUser/Vehicles/VMRS/VmrsCategory/vmrsCategory'));
const LicenseType = lazy(() => import('./InternalUser/Driver/LicenseScreen/licenseType'));
const ProductGroup = lazy(() => import('./InternalUser/Vehicles/ProductGroupScreen/ProductGroup'));
const Slippage = lazy(() => import('./InternalUser/Vehicles/SlippageScreen/Slippage'));
const CustomerScreen = lazy(() => import('./InternalUser/Controllers/Customers'));
const DepotsScreen = lazy(() => import('./InternalUser/Controllers/Depots'));
const CheckSection = lazy(() => import('./InternalUser/Vehicles/CheckSection/checkSection'));
const InternalDashboard = lazy(() => import('./InternalUser/Dashboard/Dashboard'));
const DriverType = lazy(() => import('./InternalUser/Driver/DriverTypeScreen/driverType'));
const BookingStatus = lazy(() => import('./InternalUser/Vehicles/BookingStatusScreen/bookingStatus'));
const BookingDelayReason = lazy(() => import('./InternalUser/Vehicles/BookingDelayReason/bookingDelayReason'));
const ServiceAgentFacilities = lazy(() => import('./InternalUser/Vehicles/ServiceAgentFacilitiesScreen/ServiceAgentFacilities'));
const VehicleScreen = lazy(() => import('./InternalUser/Controllers/Vehicles'));
const CollectionNDelivery = lazy(() => import('./InternalUser/Vehicles/CollectionAndDelivery/collectionNDelivery'));
const EventDocuments = lazy(() => import('./InternalUser/Vehicles/EventDocuments/eventDocuments'));
const VehicleType = lazy(() => import('./InternalUser/Vehicles/VehicleTypeScreen/VehicleType'));
const EventIntTypes = lazy(() => import('./InternalUser/Vehicles/EventInternalTypes/eventIntTypes'));
const ServiceAgent = lazy(() => import('./InternalUser/ServiceAgent'));
const EditServiceAgent = lazy(() => import('./InternalUser/ServiceAgent/editServiceAgent'));
const EditCustomer = lazy(() => import('./InternalUser/Controllers/Customers/editDashboard'));
const DefectsScreen = lazy(() => import('./InternalUser/Maintenance/Defects/defectScreen'));
const VehicleCheckChecks = lazy(() => import('./InternalUser/Vehicles/VehicleCheckCheck/vehicleCheckCheck'));
const JobBookDetail = lazy(() => import('./InternalUser/Controllers/Vehicles/ScheduleVehicle/scheduleJobDetail'));
const MaintenanceSchedules = lazy(() => import('./InternalUser/Maintenance/Schedules/maintenanceSchedules'));
const jobTabScreen = lazy(() => import('./InternalUser/Controllers/JOBS/jobTabScreen'));
const DriverScreen = lazy(() => import('./InternalUser/Controllers/Driver/index'));
const EditDriver = lazy(() => import('./InternalUser/Controllers/Driver/editDashboard'));
const ScheduleEvents = lazy(() => import('./InternalUser/Vehicles/ScheduleEventsScreen/scheduleEvents'));
const VehicleCategory = lazy(() => import('./InternalUser/Vehicles/VehicleCategoryScreen/VehicleCategory'));
const UnassignedJob = lazy(() => import('./InternalUser/Controllers/JOBS/UnassignedJobs/UnassignedJob'));
const FuelTypes = lazy(() => import('./InternalUser/Vehicles/FuelTypeScreen/FuelTypes'));
const JobReminder = lazy(() => import('./InternalUser/Controllers/JobReminder/jobReminder'));
const InternalUserSchedule = lazy(() => import('./InternalUser/Schedule'));
const VehicleDepots = lazy(() => import('./InternalUser/Controllers/Vehicles/VehicleDepots/index'));
const DefectType = lazy(() => import('./InternalUser/Vehicles/DefectTypeScreen/DefectType'));
const OutStandingDocuments = lazy(() => import('./InternalUser/Schedule/OutstandingDocuments'));
const FactoryInspectionByStatusScreen = lazy(() => import('./InternalUser/Controllers/JOBS/InternalJobsScreenFI.jsx'));
const CostCategories = lazy(() => import('./InternalUser/Vehicles/CostCategoriesScreen/CostCategories'));
const CostTypes = lazy(() => import('./InternalUser/Vehicles/CostTypeScreen/CostTypes'));
const DailyCheckInternalUser = lazy(() => import('./InternalUser/DailyChecks/dailyChecksInternalUser'));
const EmailTemplates = lazy(() => import('./InternalUser/Vehicles/EmailTemplateScreen/EmailTemplates'));
const VorScreen = lazy(() => import('./InternalUser/Controllers/VOR/VorIndex'));
const InternalUserChatting = lazy(() => import('./InternalUser/Message/InternalUserMessage'));
const EnquiriesScreen = lazy(() => import('./InternalUser/Enquiries'));
const JobTracking = lazy(() => import('./InternalUser/Controllers/JobTracking'));
const SchedulePlannerScreen = lazy(() => import('./InternalUser/Schedule/SchedulePlanner'));
const VehicleInspection = lazy(() => import('./InternalUser/VehicleInspection'));
const DeletedJobs = lazy(() => import('./InternalUser/DeletedRecords/deletedJob'));
const DeletedDefect = lazy(() => import('./InternalUser/DeletedRecords/deletedDefect'));
const DeletedSchedules = lazy(() => import('./InternalUser/DeletedRecords/deletedSchedule'));
const CompanyDetail = lazy(() => import('./InternalUser/Company'));
const CustomerVORReporting = lazy(() => import('./InternalUser/VorReporting/customerVORReporting'));
const EventSignedOff = lazy(() => import('./InternalUser/Schedule/EventsSignedOff'));
const NewIntenalDashboard = lazy(() => import('./InternalUser/InternalDashboard/internalDashboard'));
const PartUsageScreen = lazy(() => import('./InternalUser/Controllers/JOBS/partUsage'));
const FileUploaderFiles_List = lazy(() => import('./InternalUser/ContractScreens/FileUploaderFiles_List'));
const ShipmentsGrid = lazy(() => import('./InternalUser/Controllers/Shipment'));
const PartExported = lazy(() => import('./InternalUser/partExported/index.jsx'));
const VehicleSalesInvoicesExported = lazy(() => import('./InternalUser/VehicleSalesInvoicesExported/index.jsx'));
const CustomerInsuranceScreen = lazy(() => import('./InternalUser/Insurance/CustomerInsurance/index.jsx'));
const VehicleFleetInsuranceScreen = lazy(() => import('./InternalUser/Insurance/FleetInsurance/index.jsx'));
const ContractEvents = lazy(() => import('./Admin/Events/ContrctEvents'));
const StandardLabourLineTabsScreen = lazy(() => import('./Admin/StandardLabourLine'));
const UserScreen = lazy(() => import('./Admin/UserManegment'));
const BranchScreen = lazy(() => import('./Admin/Branches'));
const AdminDashboard = lazy(() => import('./Admin/Dashboard/Dashboard'));
const vehicleDailyChecksTab = lazy(() => import('./InternalUser/Vehicles/VehicleDailyChecksAdmin'));
const ReportCataloguesScreen = lazy(() => import('./Admin/ReportCatalogues'));
const MenuTab = lazy(() => import('./Admin/MenuScreen/MenuTab'));
const TreeViewTab = lazy(() => import('./Admin/TreeView/TreeViewTab'));
const Settings = lazy(() => import('./Admin/Settings/Settings'));
const Parts = lazy(() => import('./Admin/Parts'));
const PartsReceived = lazy(() => import('./Admin/Parts/partReceived'));
const PartsOrderHistory = lazy(() => import('./Admin/Parts/partHistoryGrid/partOrderHistory'));
const PartsAdjustmentHistory = lazy(() => import('./Admin/Parts/partHistoryGrid/partAdjustmentHistory'));
const WarehouseMaintenance = lazy(() => import('./Admin/warehouseMaintainance'));
const AdminPurchaseParts = lazy(() => import('./Admin/Parts/AdminPartsPurchase'));
const InspectionSheetListScreen = lazy(() => import('./Admin/InspectionSheetList'));
const VorType = lazy(() => import('./VOR/vorTypesScreen/VorType'));
const RetorqueReasons = lazy(() => import('./VOR/RetorqueReasonsScreen/RetorqueReasons'));
const RetorquePositions = lazy(() => import('./VOR/RetorquePositionsScreen/RetorquePositions'));
const WorkshopResources = lazy(() => import('./VOR/WorkshopResourcesScreen/WorkshopResources'));
const InvoiceScreen = lazy(() => import('./InternalUser/Invoices'));
const SalesInvoiceScreen = lazy(() => import('./InternalUser/Invoices/salesInvoice'));
const UpdateSalesInvoice = lazy(() => import('./InternalUser/Invoices/updateSalesInvoice'));
const MaintenanceProvider = lazy(() => import('./InternalUser/Maintenance/Provider/maintenanceProvider'));
const EditBreakdownLink = lazy(() => import('./InternalUser/Maintenance/BreakDown/editBreakDown'));
const DefetctStatusGrid = lazy(() => import('./ServiceAgent/Defects/DefectStatusGrid'));
const AllVehicleSchedules = lazy(() => import('./ServiceAgent/Schedules/vehicleAllSchedules'));
const ScheduleDashboard = lazy(() => import('./ServiceAgent/Schedules/ScheduleDashboard'));
const ServiceAgentDash = lazy(() => import('./ServiceAgent/Dashboard/ServiceAgentDash'));
const ServiceAgentBreakdown = lazy(() => import('./ServiceAgent/Breakdown'));
const BookingRequests = lazy(() => import('./ServiceAgent/Schedules/BookingRequest'));
const ConfirmedBookings = lazy(() => import('./ServiceAgent/Schedules/ConfiremdBookings'));
const ServiceAgentDefectsScreen = lazy(() => import('./ServiceAgent/Defects/ServiceAgentDefectDash'));
const AcceptRejectByAgent = lazy(() => import('./ServiceAgent/Schedules/AcceptRejectByAgent/AcceptRejectByAgent'));
const CommonJobsScreen = lazy(() => import('./ServiceAgent/JOBS/commonJobsScreen'));
const ReportsListScreen = lazy(() => import('./InternalUser/Reports/ReportsList/ReportsListScreen'));
const FilteredReportsListScreen = lazy(() => import('./InternalUser/Reports/ReportsList/FilteredReportListScreen'));
const HolidayShiftCalender = lazy(() => import('./ServiceAgent/Holiday'));
const ServiceAreaHolidays = lazy(() => import('./ServiceAgent/ServiceAreaHolidays'));
const PurchasePartsGrid = lazy(() => import('./InternalUser/Controllers/JOBS/PurchaseParts/purchasePart'));
const CustomerDashobard = lazy(() => import('./Customer/Dashboard'));
const CustomerDriverScreen = lazy(() => import('./Customer/Drivers'));
const CustomerBreakDownDashboard = lazy(() => import('./Customer/Maintainance/BreakDowns'));
const CustomerDefectsScreen = lazy(() => import('./Customer/Maintainance/Defects'));
const CustomerVehicleCheckDaily = lazy(() => import('./Customer/Maintainance/VehicleDailyChecks'));
const CustomerAllVehicleSchedules = lazy(() => import('./Customer/Maintainance/Schedules'));
const CustomerVehicleScreen = lazy(() => import('./Customer/Vehicle'));
const CustomerJobScreen = lazy(() => import('./Customer/Vehicle/Jobs'));
const CustomerDepots = lazy(() => import('./Customer/Vehicle/CustomerDepots'));
const DailyChecksCustomer = lazy(() => import('./Customer/DailyChecks/dailyChecksCustomer'));
const CustomerBreakDownDefectReporting = lazy(() => import('./InternalUser/Maintenance/BreakDownDefectReporting/customerBreakDownDefectReporting'));
const AddressScreen = lazy(() => import('./InternalUser/Address'));
const DriverDashboard = lazy(() => import('./Driver/Dashboard'));
const DriverVehicleScreen = lazy(() => import('./Driver/Vehicle'));
const DriverDash = lazy(() => import('./Driver/DriverDash/DriverDash'));
const DriverBreakDownDashboard = lazy(() => import('./Driver/Maintenance/breakdownList'));
const DriverDefectsScreen = lazy(() => import('./Driver/Maintenance/defectList'));
const CheckOutScreen = lazy(() => import('./Driver/Maintenance/CheckoutVehicle'));
const TechnicianSchedule = lazy(() => import('./Technician/Schedules'));
const TechDashboard = lazy(() => import('./Technician/engineerDashbard'));
const LeadDashboard = lazy(() => import('./Lead/Dashboard'));
const LeadEnquiriesScreen = lazy(() => import('./Lead/Enquires'));

export {
    Error404,
    RouteErrorBoundary,
    SharedHome,
    Login,
    Logout,
    ResetPassword,
    Help,
    ModelScreen,
    VehicleManufacturer,
    VmrsSubCategoryScreen,
    VmrsCategory,
    UserScreen,
    LicenseType,
    BranchScreen,
    ProductGroup,
    Slippage,
    CustomerScreen,
    DepotsScreen,
    CheckSection,
    AdminDashboard,
    InternalDashboard,
    DriverType,
    BookingStatus,
    BookingDelayReason,
    CostCenter,
    ServiceAgentFacilities,
    VehicleCategory,
    FuelTypes,
    VehicleScreen,
    EditVehicle,
    CollectionNDelivery,
    EventDocuments,
    VehicleType,
    EventIntTypes,
    ServiceAgent,
    EditServiceAgent,
    ReportCataloguesScreen,
    ReportsListScreen,
    FilteredReportsListScreen,
    VorType,
    RetorqueReasons,
    RetorquePositions,
    WorkshopResources,
    EditCustomer,
    VORTypeDetail,
    AddEditCustomer,
    DefectsScreen,
    BreakDownDashboard,
    VehicleCheckChecks,
    MaintenanceProvider,
    JobBookDetail,
    ServiceAgentDash,
    DefetctStatusGrid,
    AllVehicleSchedules,
    ScheduleDashboard,
    MaintenanceSchedules,
    jobTabScreen,
    DriverScreen,
    EditDriver,
    ScheduleEvents,
    GetAgentLocation,
    ServiceAgentDashboard,
    JobScreen,
    ServiceAgentBreakdown,
    VehicleDepots,
    //Customer screen
    CustomerDashobard,
    CustomerDriverScreen,
    BookingRequests,
    ConfirmedBookings,
    ServiceAgentDefectsScreen,
    AcceptRejectByAgent,
    CustomerBreakDownDashboard,
    CustomerDefectsScreen,
    CustomerVehicleCheckDaily,
    CustomerAllVehicleSchedules,
    CustomerVehicleScreen,
    CustomerJobScreen,
    CustomerDepots,
    UnassignedJob,
    JobReminder,
    CommonJobsScreen,
    InternalUserSchedule,
    CostCategories,
    CostTypes,
    vehicleDailyChecksTab,
    DefectType,
    OutStandingDocuments,
    DriverDashboard,
    InternalUserJobsScreen,
    DailyCheckInternalUser,
    DailyChecksCustomer,
    EmailTemplates,
    MenuTab,
    Settings,
    TreeViewTab,
    TechnicianSchedule,
    VorScreen,
    DriverVehicleScreen,
    InvoiceScreen,
    EditDepot,
    InternalUserChatting,
    ContractField,
    DriverDash,
    EnquiriesScreen,
    EnquiryEditModal,
    AddEnquiries,
    LeadDashboard,
    LeadEnquiriesScreen,
    DriverBreakDownDashboard,
    DriverDefectsScreen,
    CheckOutScreen,
    EditBreakdownLink,
    DefectEditDetails,
    JobTracking,
    VehicleInspection,
    VorReportingModal,
    CompanyDetail,
    BreakdownDefectReporting,
    DeletedJobs,
    DeletedDefect,
    DeletedSchedules,
    CustomerVORReporting,
    CustomerBreakDownDefectReporting,
    SalesInvoiceScreen,
    UpdateSalesInvoice,
    SchedulePlannerScreen,
    JobReportScreen,
    ContractList,
    AddressScreen,
    ContractEvents,
    ContractMaintenanceScreen,
    HireFleetScreen,
    ContractEditScreen,
    ContractStatusTabScreen,
    Parts,
    DashboardRecallsList,
    StandardLabourLineTabsScreen,
    HolidayShiftCalender,
    EventSignedOff,
    TechDashboard,
    ServiceAreaHolidays,
    NewIntenalDashboard,
    PurchasePartsGrid,
    PartsOrderHistory,
    PartsAdjustmentHistory,
    PartsReceived,
    PartUsageScreen,
    NotesWrapperListScreen,
    FileUploaderFiles_List,
    WarehouseMaintenance,
    AuthenticationScreen,
    TwoAuthDiasbledScreen,
    ContractStatusScreen,
    FactoryInspectionByStatusScreen,
    ShipmentsGrid,
    PartExported,
    VehicleSalesInvoicesExported,
    CustomerInsuranceScreen,
    VehicleFleetInsuranceScreen,
    AdminPurchaseParts,
    InspectionSheetListScreen
};
